import {
  TableCell,
  TableRow,
  Tooltip,
  WrapperFlex,
} from '@unimed-fesp/components';
import format from 'date-fns/format';
import React from 'react';

import { MdDelete, MdEdit, MdListAlt } from 'react-icons/md';
import { useSelector } from 'react-redux';

import { TipoEventoWebhookEnum } from '../../../enums';
import theme from '../../../styles/theme';
import EmptyContent from '../../molecules/EmptyContent';
import LoadingSpinner from '../../molecules/LoadingSpinning';
import { ButtonActions, HoverActions } from '../TableCadastroWebhook/styles';

const TableCadastroWebHookEventBody = ({
  setIsEditarModal,
  setOpenModalCadastrarEvento,
  setOpenModalDeletarEvento,
  openModalHeaders,
}) => {
  const { getWebhookEventList } = useSelector(
    (state) => state.webhookEventIntegration
  );

  const events = getWebhookEventList.data;

  if (events && events.length <= 0)
    return (
      <TableRow>
        <TableCell colSpan={6}>
          <EmptyContent />
        </TableCell>
      </TableRow>
    );

  if (getWebhookEventList.loading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {events?.map((event) => (
        <TableRow key={event.id}>
          <TableCell width={250}>{event.url}</TableCell>
          <TableCell width={300}>
            {TipoEventoWebhookEnum.returnDescricao[event.eventCode]}
          </TableCell>
          <TableCell width={120}>
            {event.createdAt
              ? format(new Date(event.createdAt), 'dd/MM/yyyy HH:mm', {
                  timeZone: 'America/Sao_Paulo',
                })
              : '-'}
          </TableCell>
          <TableCell width={120}>{event.createdUser}</TableCell>
          <TableCell width={150}>
            <WrapperFlex gap={10} alignCenter>
              <HoverActions>
                <Tooltip
                  background={theme.blue}
                  color={theme.bgWhite}
                  position="top"
                  text="Editar Evento"
                >
                  <ButtonActions
                    width={40}
                    padding={5}
                    justifyCenter
                    onClick={() => {
                      setIsEditarModal(event);
                      setOpenModalCadastrarEvento(true);
                    }}
                    background={theme.blue}
                  >
                    <MdEdit color={theme.white} size={25} />
                  </ButtonActions>
                </Tooltip>
              </HoverActions>
              <HoverActions>
                <Tooltip
                  background={theme.greenDefault}
                  color={theme.bgWhite}
                  position="left"
                  text="Lista de Headers"
                >
                  <ButtonActions
                    width={40}
                    padding={5}
                    justifyCenter
                    onClick={() =>
                      openModalHeaders({
                        isOpen: true,
                        eventId: event.id,
                      })
                    }
                    background={theme.greenDefault}
                  >
                    <MdListAlt color={theme.white} size={25} />
                  </ButtonActions>
                </Tooltip>
              </HoverActions>
              <HoverActions>
                <Tooltip
                  background={theme.red}
                  color={theme.bgWhite}
                  position="left"
                  text="Excluir"
                >
                  <ButtonActions
                    width={40}
                    padding={5}
                    justifyCenter
                    onClick={() =>
                      setOpenModalDeletarEvento({
                        isOpen: true,
                        eventId: event.id,
                      })
                    }
                    background={theme.red}
                  >
                    <MdDelete color={theme.white} size={25} />
                  </ButtonActions>
                </Tooltip>
              </HoverActions>
            </WrapperFlex>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default TableCadastroWebHookEventBody;
